import {Roles} from "@/enum/roles";
import {taskNames, taskLinks, taskTypes} from "@/enum/task_type";
import Create from "@/app/tasks/deliveryAccept/DeliveryAcceptCreate.view";
import Show from "@/app/tasks/deliveryAccept/DeliveryAcceptShow.view";

const type = taskTypes.DELIVERY_ACCEPT;
const BASE_URL = taskLinks[type];

const routes = {
    base: {
        path: BASE_URL,
        component: Create,
        meta: {
            title: taskNames[type],
            requireRole: [Roles.STOREKEEPER, Roles.CHIEF],
            getParent: () => '/'
        }
    },
    show: {
        path: BASE_URL + '/:taskId(\\d+)',
        component: Show,
        meta: {
            title: taskNames[type],
            requireRole: [Roles.CHIEF],
            getParent: () => '/',
            trackTime: true
        }
    }
};

export default Object.values(routes);
